import React, { useState, useEffect } from 'react';
import { FormControl } from '@material-ui/core';
import { useTypedTranslation } from '@app/hooks';
import { useDispatch, useSelector } from 'react-redux';
import { saveActiveFilter, useDebounce } from '@app/helpers';
import { removeActiveFilter, resetState } from '@app/store/actions';
import { IActiveFilter, TranslationsTypes } from '@app/models';
import { PasslyTextField } from '@app/components';

interface IProps {
    filtername: string;
    filterby?: string;
    label?: TranslationsTypes;
    autoFocus?: boolean;
}

export function PasslyFilterInput(props: IProps) {

    const [value, setValue] = useState('');
    const [initialClick, setInitialClick] = useState(false);

    const debouncedValue = useDebounce(value, 500);

    const activeFilters: IActiveFilter[] = useSelector((state: any) => state.listPageBar.activeFilters);

    const { filterby, filtername, label, autoFocus } = props;

    const dispatch = useDispatch();
    const { translation } = useTypedTranslation();

    useEffect(() => {
        if (debouncedValue) {
            setInitialClick(true);
            dispatch(saveActiveFilter(debouncedValue, filtername, debouncedValue, filterby));
        } else {

            if (initialClick) {
                if (activeFilters.length) {
                    dispatch(removeActiveFilter(filtername));
                }
                setInitialClick(false);
            }
            setValue('');
        }
    }, [debouncedValue]);

    useEffect(() => {
        if (!activeFilters.some((filter: IActiveFilter) => filter.name === filtername)) {
            setValue('');
        }
    }, [activeFilters]);

    const handleChange = (event: any) => {
        dispatch(resetState());
        setValue(event.currentTarget.value);
    };

    return (
        <FormControl>
            <PasslyTextField
                id={filtername}
                label={label}
                name={filtername}
                value={value}
                placeholder={translation('NAME_CONTAINS')}
                onChange={(event: any) => handleChange(event)}
                {...props}
                autoFocus={autoFocus}
            />
        </FormControl>
    );
}
